import { errorHandling } from "./";
import { JT } from "../helpers/constants/circuitCodes";

/**
 * Requesting a list of ranked players from endpoint
 * @param {string} tourCode - required: supplied as variable from umbraco partial.
 * @param {string} playerCode - required: playerTypeCode as stored in baseline.
 * @param {string} matchCode - required: MatchTypeCode as stored in baseline.
 * @param {string} ageCategoryCode - optional: ageCategoryCode as stored in baseline.
 * @param {string} seniorRankingCode - optional: seniorRankingCode as stored in baseline.
 * @param {string} skip - Index of the starting splice point (needed for progressive loading).
 * @param {string} take - Index of the ending splice point (needed for progressive loading).
 * @param {string} orderField - Order field
 * @param {boolean} isOrderAscending - asc/desc ordering
 */

export const getRankedPlayers = ({
  tourCode = "",
  playerCode = "",
  matchCode = "",
  ageCategoryCode = "",
  isRaceJunior = false,
  seniorRankingCode = "",
  nationCode = "",
  regionCode = "",
  take = "10",
  skip = "0",
  juniorEndYear,
  orderField,
  isOrderAscending
}: {
  tourCode: string;
  isRaceJunior?: boolean;
  playerCode?: string;
  matchCode?: string;
  ageCategoryCode?: string;
  seniorRankingCode?: string;
  regionCode?: string;
  nationCode?: string;
  take?: number | string;
  skip?: string;
  juniorEndYear?: number;
  orderField?: string;
  isOrderAscending?: boolean;
}) => {
  return fetch(
    `${
      process.env.HOST
    }/tennis/api/PlayerRankApi/GetPlayerRankings?circuitCode=${tourCode}${
      playerCode ? "&playerTypeCode=" + playerCode : ""
    }${
      matchCode ? "&matchTypeCode=" + matchCode : ""
    }&ageCategoryCode=${ageCategoryCode}${
      nationCode ? `&nationCode=${nationCode}` : ""
    }${regionCode ? `&zoneCode=${regionCode}` : ""}${
      tourCode == JT ? "&juniorRankingType=" + isRaceJunior : ""
    }${
      seniorRankingCode ? "&seniorRankingType=" + seniorRankingCode : ""
    }&take=${take}&skip=${skip}${
      juniorEndYear ? `&juniorEndYear=${juniorEndYear}` : ""
    }${
      orderField ? `&orderField=${orderField}` : ""
    }&isOrderAscending=${isOrderAscending}`
  ).then(res => res.json());
};

export const getHostNations = (searchString: string) => {
  return fetch(
    `${process.env.HOST}/tennis/api/NationApi/GetNationSearch?searchString=${searchString}`
  )
    .then(errorHandling)
    .then(res => res.json());
};

export const getTopRankedPlayers = ({ circuits }: { circuits: string }) => {
  return fetch(
    `${process.env.HOST}/tennis/api/PlayerRankApi/GetTopCircuitRankings${
      circuits ? `?circuits=${circuits}` : ""
    }`
  )
    .then(errorHandling)
    .then(res => res.json())
    .then(res => ({ res, host: process.env.HOST }));
};
